export class UrlUtils {
  static addQueryParamsNoReload(params: string) {
    return window.history.replaceState(
      {},
      '',
      `${window.location.href}?${params}`
    );
  }
  static removeQueryParamsNoReload() {
    return window.history.replaceState(
      {},
      '',
      `${window.location.href.split('?')[0]}`
    );
  }
}
